// /app/frontend/src/lib/notifications.js
//
// Compatibility translation layer for notifications that were persisted in
// English before the Arabic standardization pass (Feb 2026). New notifications
// are emitted directly in Arabic by the backend; this layer keeps older rows
// readable.

const TITLE_AR = {
  'Subscription expired':                                  'انتهاء الاشتراك',
  'Grace period ended':                                    'انتهت فترة السماح',
  'Trial started':                                         'بدأت التجربة',
  'Trial expired':                                         'انتهت التجربة',
  'Trial converted to Active':                             'تم تحويل التجربة إلى نشطة',
  'Communication violation in a classroom group':          'مخالفة تواصل في قاعة أنشطة',
  'Repeated communication violations — review required':   'مخالفات تواصل متكررة — مراجعة مطلوبة',
};

// Pattern-based message replacements: applied in order until one matches.
// Each entry is [regex, arabicTemplate(match)].
const MESSAGE_PATTERNS = [
  [/^Subscription expires in (\d+) day\(s\)$/, (m) => `الاشتراك ينتهي خلال ${m[1]} يوم/أيام`],
  [/^Grace period has ended\. Please renew the subscription to restore classroom access\.?$/,
    () => 'انتهت فترة السماح. يرجى تجديد الاشتراك لاستعادة الوصول إلى القاعة.'],
  [/^The 7-day grace period has ended\. Classroom access has been suspended\.?$/,
    () => 'انتهت فترة السماح البالغة 7 أيام. تم تعليق الوصول إلى القاعة.'],
  // Jun 2026 — legacy 3-day-trial English patterns removed: the backend
  // now emits session-based trial notifications directly in Arabic.
  [/^Your subscription is now Active\. Your classroom assignment remains unchanged\.?$/,
    () => 'اشتراكك الآن نشط. يبقى تعيينك في القاعة دون تغيير.'],
  [/^Your subscription end date is (.+)\. Please plan your payment\.?$/,
    (m) => `تاريخ انتهاء اشتراكك هو ${m[1]}. يرجى التخطيط للدفع.`],
  // Communication violation message
  [/^(.+) \(([A-Za-z_]+)\) tried to post a blocked message in classroom (.+)\. Reasons: (.+)\.?$/,
    (m) => `حاول ${m[1]} (${m[2]}) إرسال رسالة محظورة في القاعة ${m[3]}. الأسباب: ${m[4]}.`],
  // Communication violation threshold message
  [/^(.+) \(([A-Za-z_]+)\) reached (\d+) blocked messages\. Last classroom: (.+)\. History: (.*)$/,
    (m) => `وصل ${m[1]} (${m[2]}) إلى ${m[3]} رسالة محظورة. آخر قاعة: ${m[4]}. السجل: ${m[5]}`],
];

export const translateNotificationTitle = (title, lang) => {
  if (lang !== 'ar' || !title) return title;
  return TITLE_AR[title] || title;
};

export const translateNotificationMessage = (message, lang) => {
  if (lang !== 'ar' || !message) return message;
  for (const [re, fn] of MESSAGE_PATTERNS) {
    const m = message.match(re);
    if (m) return fn(m);
  }
  return message;
};
